import { GraphQLPageable, GraphQLPageableQueryResult } from "../types";

export function extractPageableResult<T>(data: GraphQLPageableQueryResult<T>): GraphQLPageable<T> {
  return Object.values(data || {})?.[0];
}

